import {useMemo, useState} from "react";
import * as _ from "lodash-es";
import useCheckboxGroup from "@/app/_components/forms/useCheckboxGroup";

type UseCheckboxWithInputToggleGroupOptions = {
	isEmptyFieldOmitted?: boolean;
};

type UseCheckBoxWithInputToggleGroup = {
	checkedItems: string[];
	inputValuesByCheckboxId: Record<string, string>;
	setCheckedItems: (selection: string[]) => void;
	onInputFieldChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	clearItems: () => void;
};

const useCheckboxWithInputToggleGroup: (
	options?: UseCheckboxWithInputToggleGroupOptions
) => UseCheckBoxWithInputToggleGroup = (
	{isEmptyFieldOmitted} = {isEmptyFieldOmitted: true}
) => {
	const [
		checkedItems,
		{setSelectedItems: setCheckedItems, resetItems: resetCheckedItems},
	] = useCheckboxGroup();
	const [inputValuesByCheckboxId, setInputValuesByCheckboxId] = useState<
		Record<string, string>
	>({});

	const handlers = useMemo(() => {
		return {
			onInputFieldChange: (e: React.ChangeEvent<HTMLInputElement>) => {
				setInputValuesByCheckboxId((inputValues) => {
					const value = e.target.value;
					if (!isEmptyFieldOmitted || value) {
						return {...inputValues, [e.target.name]: e.target.value};
					}
					return _.omit(inputValues, [e.target.name]);
				});
			},
			clearItems: () => {
				resetCheckedItems();
				setInputValuesByCheckboxId({});
			},
		};
	}, [isEmptyFieldOmitted, resetCheckedItems]);

	return {
		checkedItems,
		inputValuesByCheckboxId,
		setCheckedItems,
		...handlers,
	};
};

export default useCheckboxWithInputToggleGroup;
